module.exports = __webpack_public_path__ + "static/madambook-e5a7c78ede546ac74ad1460017403258.png";